/*
|--------------------------------------------------------------------------
| Views: Slider Ribbon
|--------------------------------------------------------------------------
*/

/**
 * Slider Ribbon View
 * @namespace
 */
__gh__webApp.views.sliderRibbon = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	},


	"getSubView": function(bucket){

		//Update bucket
		bucket.view.name 					= "buckets/sliderRibbon/default";
		bucket.view.sliderSettings 			= this.getSliderSettings(bucket.id);
		return bucket;
	},


	"getSliderSettings":function(bucketID){
		var sliderSettings = {
			"infinite":true,
			"speed":300,
			"slidesToShow":3,
			"slidesToScroll":3,
			"lazyLoad":"ondemand",
			"responsive":[
				{
					"breakpoint":1024,
					"settings":{"slidesToShow":3,"slidesToScroll":3/*,"appendArrows":"#gh-slider-nav-bottom-"+bucketID*/}
				},
				{
					"breakpoint":600,
					"settings":{"slidesToShow":2,"slidesToScroll":2/*,"appendArrows":"#gh-slider-nav-bottom-"+bucketID*/}
				},
				{
					"breakpoint":480,
					"settings":{"slidesToShow":1,"slidesToScroll":1/*,"appendArrows":"#gh-slider-nav-bottom-"+bucketID*/}
				}
			]
		};
		return sliderSettings;
	}
};
